import axiosInstance from './axiosInstance';

const get = (url) => {
  return axiosInstance.get(url);
};

const post = (url, payload) => {
  return axiosInstance.post(url, payload);
};

const postFiles = (url, payload) => {
  const axiosLocal = axiosInstance;
  return axiosLocal.post(url, payload);
};

const put = (url, payload) => {
  return axiosInstance.put(url, payload);
};

const deleteItems = (url, payload) => {
  return axiosInstance.delete(url, payload);
};

const patch = (url, payload) => {
  return axiosInstance.patch(url, payload);
};

export const http = {
  get,
  post,
  postFiles,
  put,
  deleteItems,
  patch,
};
